import React from 'react'
import Head from 'next/head'
import AppBar from 'Components/AppBar'
import { connect } from 'react-redux'
import Markdown from 'react-markdown'
import Breadcrumb from 'Components/Breadcrumb'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import prnt from 'Components/Stores/StoresPage.scss'
import plph from 'Components/ProductListPage/components/ProductListPageHeader/ProductListPageHeader.scss'
import { CodeRenderer, LinkRenderer } from 'Utils/helpers/markDownRenderers'
import cmsContentQuery from 'Utils/api/gql/queries/cmsContent'
import { Query } from 'react-apollo'
import { cmsContent, cmsContent_cmsContent } from 'Utils/api/gql/types'
import LoadingPage from 'Components/LoadingPage'
import Footer from 'Components/Footer'
import Error from './_error'
import has from 'lodash/has'
import { SVGArrowBack } from 'Components/SVGCollection'
import StoresMap from 'Components/Stores/StoresMap'
import { contactStores } from 'Utils/data/stores'
import { goBack } from 'Utils/helpers/routerHelper';

class ArticlePage extends React.Component {
    renderContent = (article: cmsContent_cmsContent) => {
        const breadcrumbData = [
            {
              href: '/',
              title: 'Főoldal',
              gtmName: 'Home'
            },
            {
              href: `/kapcsolat`,
              title: 'Kapcsolat',
              gtmName: 'Contact'
            }
        ]

        return (
            <div>
                <Head>
                    <title>{article.meta_title || article.title}</title>
                    <meta name="description" content={article.meta_description || ''} />
                    <meta name="keywords" content={article.meta_keywords || ''} />
                </Head>

                <AppBar
                    viewType={AppBarViewType.SubPage}
                    pageTitle={article.title}
                    pageType="Home"
                    breadcrumb="Home / Contact"
                 />

                <div className={cn(cg.gridContainer, prnt.storesContainer)}>

                    <div className={cn(cg.showForMedium, prnt.breadcrumbContainer)}>
                        <Breadcrumb data={breadcrumbData} />
                    </div>

                    <div className={cn(cg.gridX, plph.productListPage__header, cg.showForLarge)}>
                        <div className={cn(cg.cell, cg.shrink)}>
                            <a className={plph.linkBack} onClick={goBack}>
                            <span className={cg.showForSr}>
                                Vissza
                            </span>

                            <span aria-hidden="true">
                                <SVGArrowBack width="32" height="32" />
                            </span>
                            </a>
                        </div>
                        <div className={cn(cg.cell, cg.auto)}>
                            <h1 className={plph.h1}>
                                {article.title}
                            </h1>
                        </div>
                    </div>
                    <div className={cn(cg.gridX, cg.gridMarginX)}>
                        <div className={cn(cg.cell, cg.medium5)}>
                            <div className={cn(prnt.articleContent)}>
                                <Markdown
                                    renderers={{
                                        code: CodeRenderer,
                                        link: LinkRenderer
                                    }}
                                >
                                    {article.content}
                                </Markdown>
                            </div>
                        </div>

                        <div className={cn(cg.cell, cg.medium7)}>
                            <StoresMap stores={contactStores} currentStore={contactStores[0]} />
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
        )
    }


    render() {
        return (
            <Query<cmsContent>
                query={cmsContentQuery}
                partialRefetch={true}
                variables={{ url_key: 'kapcsolat' }}
            >
                {({ error, data, refetch }) => {
                    if (error) {
                        if (has(error, 'graphQLErrors.0.extensions.validation.url_key')) {
                            return <Error statusCode={404} />
                        } else {
                            return <Error statusCode={500} />
                        }
                    }

                    if (data && data.cmsContent) {
                            return this.renderContent(data.cmsContent)
                    }

                    return <LoadingPage />
                }}
            </Query>
        );

    }
}

const mapStateToProps = ({ session }: Redux.IReduxState) => ({
    session
})

export default connect(mapStateToProps)(ArticlePage)
